import { Menu, Portal } from '@chakra-ui/react'
import { Dispatch, FC, SetStateAction } from 'react'

import { Button, Typography } from '@/components/ui'
import MovingStripes from '@/components/ui/animations/MovingStripes'

import ArrowDown2 from '@/assets/icons/arrow-down-2.svg'

import { PLATFROMS_LANGUAGES } from '@/constants/languages'
import { ISelectedPlatform, TPlatformValue } from '@/types/uploadForm.interface'

type TAvailableFillLanguage = {
	value: TPlatformValue
	label: string
}

interface IFormAutoFillingProps {
	currentPlatform: ISelectedPlatform
	availableFillLanguages: TAvailableFillLanguage[]
	handleAutoFill: () => void
	sourceAutoFillLang: TPlatformValue | ''
	setSourceAutoFillLang: Dispatch<SetStateAction<TPlatformValue | ''>>
	isProcessing: boolean
}

const FormAutoFilling: FC<IFormAutoFillingProps> = ({
	currentPlatform,
	availableFillLanguages,
	handleAutoFill,
	sourceAutoFillLang,
	setSourceAutoFillLang,
	isProcessing
}) => {
	const fillingLanguage = sourceAutoFillLang
		? PLATFROMS_LANGUAGES[sourceAutoFillLang]
		: ''

	const fillBtnDisabled = isProcessing

	return (
		<>
			{currentPlatform?.autoFilling &&
			currentPlatform?.processing === 'autofill' ? (
				<MovingStripes
					bgColor='blue-50'
					text={`Filling from ${fillingLanguage}...`}
					className='mb-8'
				/>
			) : currentPlatform?.autoFilling &&
			  currentPlatform?.processing !== 'autofill' ? (
				<div className='flex justify-between items-center bg-blue-50 py-[22px] px-4 rounded-[12px] mb-8'>
					{availableFillLanguages.length > 1 ? (
						<Menu.Root positioning={{ placement: 'bottom-end' }}>
							<Menu.Trigger asChild>
								<div className='flex items-center gap-2 cursor-pointer'>
									<Typography
										variant='text'
										className='text-[16px] !font-[500] !leading-[140%]'
									>
										Auto-fill Form from
									</Typography>
									<Button
										className='!text-black !p-0 !border-b !rounded-none'
										size='lg'
									>
										<Typography
											as='span'
											variant='text-semibold'
											className='text-base'
										>
											{fillingLanguage}
										</Typography>
									</Button>
									<ArrowDown2 />
								</div>
							</Menu.Trigger>
							<Portal>
								<Menu.Positioner>
									<Menu.Content>
										{availableFillLanguages.map(({ value, label }) => (
											<Menu.Item
												key={value}
												value={value}
												onClick={() => setSourceAutoFillLang(value)}
											>
												{label}
											</Menu.Item>
										))}
									</Menu.Content>
								</Menu.Positioner>
							</Portal>
						</Menu.Root>
					) : (
						<Typography
							variant='text'
							className='text-[16px] !font-[500] !leading-[140%]'
						>
							Auto-fill Form from {fillingLanguage}
						</Typography>
					)}

					<Button
						className='bg-blue-100 px-3'
						classNameText='text-black'
						disabled={fillBtnDisabled}
						onClick={handleAutoFill}
					>
						Fill Form
					</Button>
				</div>
			) : null}
		</>
	)
}

export default FormAutoFilling
